import { render, staticRenderFns } from "./PublicShareAuthSidebar.vue?vue&type=template&id=71a964ef&scoped=true"
import script from "./PublicShareAuthSidebar.vue?vue&type=script&lang=js"
export * from "./PublicShareAuthSidebar.vue?vue&type=script&lang=js"
import style0 from "./PublicShareAuthSidebar.vue?vue&type=style&index=0&id=71a964ef&prod&lang=css"
import style1 from "./PublicShareAuthSidebar.vue?vue&type=style&index=1&id=71a964ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a964ef",
  null
  
)

export default component.exports